// ============================================================
// BUNDLE EDITS (plan modes-rework, stage 4) - the edits one Always on item
// or one Solo mode takes on its bench: a trigger, a one-at-a-time group,
// and the read that turns a draft into what is saved. Each a new object.
//
// A GROUP IS TYPED BY NAME: its id is made from the name, so two Solo
// modes made apart (in the library, on two sheets) that name the same
// group are one group wherever they meet.
//
// Pure. Zero React dependency.
// ============================================================
import { readAlwaysOn, readSoloModes, type EffectItem, type SoloMode } from './soloModes';
import type { OwnState } from './effectWhen';

/**
 * The id a group of this name has, under a prefix no fixed tab uses: the name without accents, case or punctuation
 * ("Doctrina Táctica", "doctrina tactica" and "Doctrina-Táctica" are one group).
 */
export const groupIdOf = (name: string): string =>
  `g-${name
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')}`;

/**
 * The mode in the group of this name; a blank name takes it out of any group. The SAME name keeps the group as it
 * is - its id too, which may be an older sheet's own (`stanceMigration`), so its fellows still hold one at a time.
 */
export function withGroupNamed(mode: SoloMode, name: string): SoloMode {
  const named = name.trim();
  if (named === (mode.group?.name ?? '')) return mode;
  const { group: _was, ...rest } = mode;
  return named ? { ...rest, group: { id: groupIdOf(named), name: named } } : rest;
}

/** The item with this trigger; null takes the trigger away (the key gone, never undefined). */
export function withTrigger(item: EffectItem, whileOwn: OwnState | null): EffectItem {
  const { whileOwn: _was, ...rest } = item;
  return whileOwn ? { ...rest, whileOwn } : rest;
}

/** A draft as it is saved, read as the sheet's lists read it; null when it has no name. */
export function bundleOf(kind: 'alwaysOn' | 'soloMode', draft: EffectItem | SoloMode): EffectItem | SoloMode | null {
  return (kind === 'alwaysOn' ? readAlwaysOn([draft]) : readSoloModes([draft]))[0] ?? null;
}
